export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
export const API_URL_V2 = process.env.REACT_APP_API_URL_V2 || 'http://localhost:3000/api/v2';
export const NODE_URL = process.env.REACT_APP_NODE_URL || 'http://localhost:3000';
export const LOGGER_SERVICE_URL = process.env.REACT_APP_LOGGER_SERVICE_URL;

export const APK_CONTOUR = process.env.REACT_APP_APK_CONTOUR || 'production';
export const APK_LINK = LOGGER_SERVICE_URL + `/v1/releases/mobile/download/cloud?platform=web&profile=${APK_CONTOUR}`;

export const getContentType = () => ({
  'Content-Type': 'application/json',
});

export const getCompaniesUrl = (path: string = '') => '/companies' + path;
export const getPersonsUrl = (path: string = '') => '/persons' + path;
export const getPartyRelationsUrl = (path: string = '') => '/relations' + path;
export const getContractsUrl = (path: string = '') => '/contracts' + path;
export const getDocumentsUrl = (path: string = '') => '/documents' + path;
export const getServiceRequestsUrl = (path: string = '') => '/serviceRequests' + path;
export const getWorkContentsUrl = (path: string = '') => '/workContents' + path;
export const getReasonDelaysUrl = (path: string = '') => '/delayReasons' + path;
export const getDictionaryUrl = (path: string = '') => '/dicts' + path;
export const getImportsUrl = (path: string = '') => '/imports' + path;
export const getImportUrl = (path: string = '') => '/import' + path;
export const getUserAccountsUrl = (path: string = '') => '/accounts' + path;
export const getAccountGroupsUrl = (path: string = '') => '/brigades' + path;
export const getAddressItemUrl = (path: string = '') => '/addressItems' + path;
export const getAuthUrl = (path: string = '') => '/api/auth' + path;
export const getFiltersUrl = (path: string = '') => '/filtersSets' + path;
export const getReportsUrl = (path: string = '') => '/reports' + path;
export const getExportUrl = (path: string = '') => '/export' + path;
export const getDevicesUrl = (path: string = '') => '/devices' + path;
export const getWorkStagesUrl = (path: string = '') => '/workStages' + path;
export const getModelsUrl = (path: string = '') => '/models' + path;
export const getDashboardUrl = (path: string = '') => '/dashboard' + path;
